import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  proplayers,
  playersGames,
  playerSuggestion,
  openings,
  openingsuggestion,
  openingId,
} from '../const';

@Injectable({
  providedIn: 'root',
})
export class ProplayerService {
  constructor(private http: HttpClient) {}

  playerRecordData(
    query: any,
    pageNumber: number,
    sortOrder: string,
    side: string
  ) {
    let data = { query };
    return this.http.post<any>(
      `${proplayers}?page=${pageNumber}&sort=${sortOrder}&side=${side}`,
      data
    );
  }

  playeredGames(id: number) {
    let data = { id };
    return this.http.post<any>(`${playersGames}`, data);
  }

  playerSuggestionData(player: string) {
    return this.http.get<any>(`${playerSuggestion}?player=${player}`);
  }

  openingsData(pageNumber: any, ecodata: any, openingdata: any) {
    return this.http.get<any>(
      `${openings}?page=${pageNumber}&eco=${ecodata}&opening=${openingdata}`
    );
  }

  openingsuggestionData(data: any) {
    return this.http.get<any>(`${openingsuggestion}?opening=${data}`);
  }

  openingIdData(data: any) {
    return this.http.get<any>(
      `${openingId}?page=${data.page}&id=${data.gameId || ''}&moves=${data.move || ''}`
    );
  }
}
